import setShelters from './setShelters';
import setShelter from './setShelter';
import resetCurrentShelter from './resetCurrentShelter';
import setAvailableShelters from './setAvailableShelters';

export default {
  setShelters,
  setShelter,
  resetCurrentShelter,
  setAvailableShelters,
};
